export const SEARCH_USER_REQUESTED = 'SEARCH_USER_REQUESTED';
export const SEARCH_USER_FAILED = 'SEARCH_USER_FAILED';
export const SEARCH_USER_SUCCESSFUL = 'SEARCH_USER_SUCCESSFUL';
export const GET_COACH_APPLICATIONS_REQUESTED = 'GET_COACH_APPLICATIONS_REQUESTED';
export const GET_COACH_APPLICATIONS_SUCCESSFUL = 'GET_COACH_APPLICATIONS_SUCCESSFUL';
export const GET_COACH_APPLICATIONS_FAILED = 'GET_COACH_APPLICATIONS_FAILED';
export const COACH_APPLICATION_UPGRADE_REQUESTED = 'COACH_APPLICATION_UPGRADE_REQUESTED';
export const COACH_APPLICATION_UPGRADE_FAILED = 'COACH_APPLICATION_UPGRADE_FAILED';
export const COACH_APPLICATION_UPGRADE_SUCCESSFUL = 'COACH_APPLICATION_UPGRADE_SUCCESSFUL';
export const ERASE_CURRENT_USER_DATA = 'ERASE_CURRENT_USER_DATA';
export const START_LOADER = 'START_LOADER';
export const STOP_LOADER = 'STOP_LOADER';
export const UPGRADE_STUDENT_SUCCESSFUL = 'UPGRADE_STUDENT_SUCCESSFUL';
export const OVERRIDE_STUDENT_SUCCESSFUL = 'OVERRIDE_STUDENT_SUCCESSFUL';
export const STUDENT_EVALUATION_SUCCESSFUL = 'STUDENT_EVALUATION_SUCCESSFUL';
export const DELETE_COACH_SUCCESSFUL = 'DELETE_COACH_SUCCESSFUL';
export const ADD_COACH = 'ADD_COACH_SUCCESSFUL';
export const MODIFY_COLLEGE = 'MODIFY_COLLEGE_SUCCESSFUL';
export const RESET_DELETE_COACH = 'RESET_DELETE_COACH';
export const RESET_ADD_COACH = 'RESET_ADD_COACH';
export const GET_COACHES_FROM_DB = 'GET_COACHES_FROM_DB';
export const ADD_COLLEGE_SUCCESSFUL = 'ADD_COLLEGE_SUCCESSFUL';
export const RESET_STUDENT_VALUES = 'RESET_STUDENT_VALUES';
export const GET_STUDENTS_FOR_STUDENT_EXPLORER = 'GET_STUDENTS_FOR_STUDENT_EXPLORER';
export const DELETE_COACH_APPLICATION_SUCCESSFUL = 'DELETE_COACH_APPLICATION_SUCCESSFUL';
export const RESET_STUDENT_DASHBOARD_REQUESTED = 'RESET_STUDENT_DASHBOARD_REQUESTED';
export const RESET_STUDENT_DASHBOARD_SUCCESSFUL = 'RESET_STUDENT_DASHBOARD_SUCCESSFUL';
export const RESET_STUDENT_DASHBOARD_FAILED = 'RESET_STUDENT_DASHBOARD_FAILED';
export const START_ES_LOADER = 'START_ES_LOADER';
export const STOP_ES_LOADER = 'STOP_ES_LOADER';
export const GET_ES_STUDENTS_FOR_STUDENT_EXPLORER = 'GET_ES_STUDENTS_FOR_STUDENT_EXPLORER';
export const SEARCH_ES_USER_REQUESTED = 'SEARCH_ES_USER_REQUESTED';
export const SEARCH_ES_USER_FAILED = 'SEARCH_ES_USER_FAILED';
export const SEARCH_ES_USER_SUCCESSFUL = 'SEARCH_ES_USER_SUCCESSFUL';



// WEBPACK FOOTER //
// ./src/containers/Admin/actionTypes.js